module.exports = __webpack_public_path__ + "img/coxa-distal-e.0c8ec285.png";